import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { COMPANY } from "@/lib/data";
import { Footer } from "@/components/Footer";

export const LegalLayout = ({ title, updated, children }) => {
  return (
    <div className="bg-[#050505] text-white min-h-screen">
      <header className="border-b border-white/10 sticky top-0 bg-[#050505]/90 backdrop-blur-xl z-20">
        <div className="mx-auto max-w-[1000px] px-5 md:px-10 h-20 flex items-center justify-between">
          <Link to="/" data-testid="legal-logo" className="flex items-center gap-3">
            <img src={COMPANY.logo} alt="Auto-Hire STL" className="h-11 w-11 object-contain rounded-md" />
            <span className="font-display font-extrabold text-lg">AutoHire <span className="text-gold-gradient">STL</span></span>
          </Link>
          <Link to="/" data-testid="legal-back" className="flex items-center gap-2 text-sm text-white/70 hover:text-[#F2B705] transition-colors">
            <ArrowLeft size={16} /> Back to site
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-[820px] px-5 md:px-10 py-16 md:py-24">
        <h1 className="font-display font-black tracking-tighter text-4xl md:text-5xl leading-[0.95]">{title}</h1>
        <p className="text-white/40 text-sm mt-3">Last updated: {updated}</p>
        <p className="text-white/50 text-sm mt-1">{COMPANY.legalName}</p>
        <div className="mt-10 space-y-8 legal-body">{children}</div>
      </main>

      <Footer />
    </div>
  );
};

export const LegalSection = ({ heading, children }) => (
  <section>
    <h2 className="font-display font-bold text-xl md:text-2xl text-white mb-3">{heading}</h2>
    <div className="text-white/60 font-light leading-relaxed space-y-3 text-[15px]">{children}</div>
  </section>
);
